import apiClient from '../utils/api/ApiClient';
import { API_ENDPOINTS } from '../constants/api.constants';
import type {
    InternalPeopleList,
    ListOnNewBrandsResult,
    UpdateListOnNewBrandsRequest,
} from '../types/accessManagement.types';

type Envelope<T> = { status: string; message?: string; data: T };

export async function listInternalPeople(searchText?: string): Promise<InternalPeopleList> {
    const response = await apiClient.get<Envelope<InternalPeopleList>>(
        API_ENDPOINTS.ADMIN_USER.LIST,
        searchText ? { params: { searchText } } : undefined
    );
    return response.data;
}

export async function updateListOnNewBrands(
    body: UpdateListOnNewBrandsRequest
): Promise<ListOnNewBrandsResult> {
    const response = await apiClient.patch<Envelope<ListOnNewBrandsResult>>(
        API_ENDPOINTS.ADMIN_USER.LIST_ON_NEW_BRANDS,
        body
    );
    return response.data;
}
